import {defineNuxtRouteMiddleware, useAuth, useNuxtApp} from '#imports';

/**
 * For each step change, check whether the user is logged-in. This information is used by
 * layouts/default.vue.
 */
export default defineNuxtRouteMiddleware(async () => {
    const nuxtApp = useNuxtApp();
    const {$pinia} = nuxtApp;
    const {isLogged} = useAuth($pinia);

    await isLogged();
});
